export function FormatNumberInEur(number, compact, symbol) {
  if (compact) {
    number = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "EUR",
      notation: "compact",
    }).format(number);
  } else {
    number = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(number);
  }
  if (symbol) {
    return number.slice(0, -1);
  } else {
    return number;
  }
}

export function FormatNumberInPerc(number) {
  if (number != null) {
    return number > 0 ? "+" + number + "%" : number + "%";
  } else {
    return "null";
  }
}

export function FormatEurInNumber(eur) {
  var thousandSeparator = (1111).toLocaleString().replace(/1/g, "");
  var decimalSeparator = (1.1).toLocaleString().replace(/1/g, "");

  return parseFloat(
    eur
      .replace(new RegExp("\\" + thousandSeparator, "g"), "")
      .replace(new RegExp("\\" + decimalSeparator), ".")
  );
}

export function FormatPercentage(percentage) {
  return Math.round(percentage) + "%";
}

// delta from n2 to n1
export function CalcDeltaChart(index, arrNumbers) {
  if (index > 0) {
    let n1 = arrNumbers[index - 1],
      n2 = arrNumbers[index];
    let delta =
      Math.round(((n2 / n1) * 100 - 100) * 100) / 100 < 0
        ? Math.round(((n2 / n1) * 100 - 100) * 100) / 100
        : "+" + Math.round(((n2 / n1) * 100 - 100) * 100) / 100;

    return delta + " %";
  } else {
    return "";
  }
}

export function CalcDeltaTable(n1, n2) {
  let delta =
    Math.round(((n2 / n1) * 100 - 100) * 100) / 100 < 0
      ? Math.round(((n2 / n1) * 100 - 100) * 100) / 100
      : "+" + Math.round(((n2 / n1) * 100 - 100) * 100) / 100;

  return delta + " %";
}

export function DefaultDateTimeFormatOptions() {
  return {
    dateStyle: "short",
    timeStyle: "short",
    hour12: false,
  };
}
